import ProductInformation from 'Components/SignIn/ProductInformation';
import { ReactComponent as PaytronLogo } from 'Components/UI_Library/Icons/Paytron.svg';
import classes from './AuthPageWrapper.module.css';

type Props = {
    children: React.ReactNode;
};

const AuthPageWrapper = (props: Props) => (
    <div className={classes.container}>
        <div className={classes.header}>
            <a href="/" title="Paytron">
                <PaytronLogo fill="#133D9E" />
            </a>
        </div>
        <div className={classes.formContainer}>{props.children}</div>
        <div className={classes.information}>
            <div className={classes.content}>
                <ProductInformation />
            </div>
        </div>
    </div>
);

export default AuthPageWrapper;
